/* eslint-disable react/prop-types */
import React from 'react';
import { insuranceOptions, insurersList, monthsList } from '../../utils/helpers';
import _ from 'lodash';
import './index.less';

export default function ViewReminder({ reminder }) {
  let { insuranceType, insurer, renewalMonth, annualPayment } = reminder;

  const Icon = _.get(_.find(insuranceOptions, { value: insuranceType }), 'icon');
  insuranceType = _.get(_.find(insuranceOptions, { value: insuranceType }), 'label');
  insurer = _.get(_.find(insurersList, { value: insurer }), 'label');
  renewalMonth = _.get(_.find(monthsList, { value: renewalMonth }), 'label');

  return(
    <div className="view-reminder">
      {/* Type */}
      <div className="view-reminder-header">
        <Icon
          fill="#895d85"
          size="40"
        />
        <span>{insuranceType}</span>
      </div>

      {/* Insurer */}
      <div className="view-reminder-field">
        <span>Seguradora</span><span>{insurer}</span>
      </div>

      {/* Renewal */}
      <div className="view-reminder-field">
        <span>Renovação</span><span>{renewalMonth}</span>
      </div>

      {/* Annual Payment */}
      {annualPayment &&
        <div className="view-reminder-field">
          <span>Prémio anual</span><span>{`${annualPayment} €`}</span>
        </div>
      }
    </div>
  );
}